import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { getData, addData, updateData, getregistrationCategoryType, getpaymentType, getregType, getoccupancyType, geteventType, getcurrencyType, getcountries, getReceiptId, getprogramManager, getseriesType} from '../../../services/event/participantForm/onsiteParticipantServices';
import { Modal, Button, Form } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import Header from '../../../components/Layout/Header';
import Footer from '../../../components/Layout/Footer';
import Sidebar from '../../../components/Layout/Sidebar';
import Spinner from '../../../components/Spinner';
import Swal from 'sweetalert2';

const subDomain = localStorage.getItem('sub_domain') || '';

const statusClassMap = {
  0: 'bg-secondary',
  1: 'bg-warning',
  2: 'bg-success',
};

const statusLabelMap = {
  0: 'Pending',
  1: 'Waiting',
  2: 'Paid',
};

const OnsiteParticipantForm = () => {
  const [dataList, setDataList] = useState([]);
  const [form, setForm] = useState({
    id: '',
    billing_address : '',
    billing_countries : '',
    billing_email : '',
    billing_full_name : '',
    billing_phone_no : '',
    currency_type : '',
    event_date : '',
    event_title : '',
    no_of_ticket : '',
    occupancy_type : '',
    payment_id : '',
    payment_type : '',
    participant_type: 'onsite',
    onsite_status : 0,
    reg_amount : '',
    reg_category : '',
    reg_type : '',
    series : '',
    sub_domain : subDomain,
    subject : '',
    note: '',
    notes: [],
    total_no_of_nights : '',
    updatedAt : ''
  });
  const [modalType, setModalType] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [errors, setErrors] = useState({});

  // Filter States
  const [dropdownData, setDropdownData] = useState({
    registrationCategoryType: [],
    paymentType: [],
    regType: [],
    occupancyType: [],
    eventType: [],
    currencyType: [],
    countries: [],
  });
  const [showCategoryDropdown, setShowCategoryDropdown] = useState(false);
  const [filteredRegistrationCategories, setFilteredRegistrationCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  // Fetch all dropdown data
  const fetchDropdownData = useCallback(async () => {
    try {
      const [regCategory, payment, reg, occupancy, event, currency, country] = await Promise.all([
        getregistrationCategoryType(),
        getpaymentType(),
        getregType(),
        getoccupancyType(),
        geteventType(),
        getcurrencyType(),
        getcountries(),
      ]);
 
      setDropdownData({
        registrationCategoryType: regCategory,
        paymentType: payment,
        regType: reg,
        occupancyType: occupancy,
        eventType: event,
        currencyType: currency,
        countries: country,
      });
    } catch (error) {
      console.error('Error fetching dropdown data:', error);
    }
  }, []);
 
  const fetchData = useCallback(async () => {
    try {
      const data = await getData({sub_domain: subDomain, participant_type:'onsite'});
      setDataList(data);
    } catch (error) {
      console.error('Failed to fetch data:', error);
    }
  }, []);
  const fetchReceiptId = useCallback(async (type) => {
      try {
          const result = await getReceiptId({ sub_domain: subDomain, type });
          console.log('Result:', result);
   
          if (result && result[type]) {
            setForm((prevForm) => ({
              ...prevForm,
              payment_id: result[type]
            }));
          }
      } catch (error) {
          console.error('Error fetching payment ID:', error);
      }
  }, []);

  const fetchseriesType = useCallback(async () => {
      try {
        const data = await getseriesType({ sub_domain: subDomain });
        if (data && data.length > 0) {
          const seriesInfo = data[0]; // Assuming you're using the first item
          setForm(prev => ({
            ...prev,
            series: seriesInfo.series || ''       
          }));
          console.log("Setting series:", seriesInfo.series);

        }
      } catch (error) {
        console.error('Failed to fetch series info:', error);
      }
    }, []);
   
 
 
  useEffect(() => {
    
    // fetchReceiptId();
    const fetchDataAsync = async () => {
      setLoading(true); 
      await fetchData();
      await fetchDropdownData();
      await fetchseriesType(); 
      // Optional 2 second delay
      await new Promise((resolve) => setTimeout(resolve, 1000));
      setLoading(false); 
    };
  
    fetchDataAsync();
 
  }, [fetchData, fetchDropdownData, fetchReceiptId, fetchseriesType]);
     
  const handleChange =async (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: '' }));
  
    // If the Registration Type changes, filter the Registration Category
    if (name === "reg_type") {
        if (value) {
            const filteredCategories = dropdownData.registrationCategoryType.filter(
                (item) => item.type === value
            );
            setFilteredRegistrationCategories(filteredCategories);
            setShowCategoryDropdown(filteredCategories.length > 0); // Show only if categories exist
            // Reset category when type changes
            setForm((prev) => ({ ...prev, reg_category: "" }));
        } else {
            setFilteredRegistrationCategories([]);
            setShowCategoryDropdown(false); // Hide the select input
        }
    }
    
  };

  const validateForm = () => {
    const newErrors = {};
    if (!form.payment_type) newErrors.payment_type = 'Payment Type is required.';
    if (!form.billing_full_name) newErrors.billing_full_name = 'Billing Full Name is required.';
    if (!form.billing_email) newErrors.billing_email = 'Billing Email is required.';
    if (!form.billing_phone_no) newErrors.billing_phone_no = 'Billing Phone is required.';
    if (!form.billing_countries) newErrors.billing_countries = 'Billing Country is required.';
    if (!form.billing_address) newErrors.billing_address = 'Billing Address is required.';
    if (!form.currency_type) newErrors.currency_type = 'Currency is required.';
    if (!form.reg_amount) newErrors.reg_amount = 'Registration Amount is required.';
    if (!form.no_of_ticket) newErrors.no_of_ticket = 'Number of Tickets is required.';
    if (!form.reg_type) newErrors.reg_type = 'Registration Type is required.';

    if (showCategoryDropdown && !form.reg_category) {
      newErrors.reg_category = 'Registration Category is required.';
    }

    if (modalType === 'edit' && !form.note?.trim()) {
      newErrors.note = 'Note is required.';
    }
    
    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (form.billing_email && !emailRegex.test(form.billing_email)) {
      newErrors.billing_email = 'Invalid email format.';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  

  const handleSubmit = async () => {
  if (!validateForm()) return;

  try {
    let updatedForm = { ...form, participant_type: form.participant_type || 'onsite' };

    // Append new note to history
    let history = Array.isArray(form.notes) ? [...form.notes] : [];
    if (form.note && form.note.trim() !== '') {
      const now = new Date();
      const formatted =
        now.getFullYear() + '-' +
        String(now.getMonth() + 1).padStart(2, '0') + '-' +
        String(now.getDate()).padStart(2, '0') + ' ' +
        String(now.getHours()).padStart(2, '0') + ':' +
        String(now.getMinutes()).padStart(2, '0');
      history.push({ date: formatted, value: form.note.trim(), status: statusLabelMap[form.onsite_status] ?? 'Pending' });
    }
    updatedForm.note = history.length ? JSON.stringify(history) : null;

    if (modalType === 'add') {
      await addData(updatedForm);
    } else if (modalType === 'edit') {
      await updateData({ ...updatedForm, onsite_status: 0 });
    }

    fetchData();
    setShowModal(false);
    Swal.fire({
      icon: 'success', title: 'Success',
      text: `Onsite participant form ${modalType === 'add' ? 'added' : 'updated'} successfully!`,
      timer: 2000, showConfirmButton: false,
    });
  } catch (error) {
    Swal.fire({ icon: 'error', title: 'Error', text: 'Something went wrong while submitting the form!' });
  }
};

  const openModal = async (type, data = {
    id: '',
    billing_address: '',
    billing_countries: '',
    billing_email: '',
    billing_full_name: '',
    billing_phone_no: '',
    currency_type: '',
    event_date: '',
    event_title: '',
    no_of_ticket: '',
    occupancy_type: '',
    payment_id: '',
    payment_type: '',
    participant_type: 'onsite',
    reg_amount: '',
    reg_category: '',
    reg_type: '',
    series: '',
    sub_domain: subDomain,
    subject: '',
    total_no_of_nights: '',
    note: '',
    notes: [],
    updatedAt: ''
    }) => {
        setErrors({});
        setModalType(type);

   
    
    const normalizedData = {
      ...data,
    };

    // Parse note history for edit mode
    if (type === 'edit') {
      const history = parseNoteHistory(data.note);
      normalizedData.note = '';        // clear input field
      normalizedData.notes = history;  // load history
    } else {
      normalizedData.note = '';
      normalizedData.notes = [];
    }

    //  Filter registration categories
    if (normalizedData?.reg_type) {
      const filteredCategories = dropdownData.registrationCategoryType.filter(
        (item) => item.type === normalizedData.reg_type
      );
      setFilteredRegistrationCategories(filteredCategories);
      setShowCategoryDropdown(filteredCategories.length > 0);
    } else {
      setFilteredRegistrationCategories([]);
      setShowCategoryDropdown(false);
    }

    if (type === 'add') {
        normalizedData.payment_type = 'onsite';
        normalizedData.participant_type = 'onsite';
    }

    //  Handle "add" mode (fetch receipt ID and series)
    if (type === 'add') {
        const data = await getprogramManager({ sub_domain: subDomain });
       //  Check if no program manager is found
        if (!data || data.length === 0) {
        Swal.fire({
          icon: 'warning',
          title: 'Program Manager Not Found',
          text: 'No Program Manager details found. Please update the Program Manager details.',
          showCancelButton: true,
          confirmButtonText: 'Update Now',
          cancelButtonText: 'Cancel',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33'
        }).then((result) => {
          if (result.isConfirmed) {
            // Redirect to program manager page
            window.location.href = `/programManager`; // replace baseurl with your actual base URL if needed
          }
        });
        return;
      }

      const status = data?.[0]?.status ?? true; // fallback to 1 if undefined
      //Show alert and stop if inactive
      if (status === false) {
        Swal.fire({
          icon: 'warning',
          title: 'Program Manager Inactive',
          text: 'Your Program Manager details are inactive. Please contact the admin.',
          confirmButtonColor: '#3085d6'
        });
        return;
      }
      
      try {
        const result = await getReceiptId({ sub_domain: normalizedData.sub_domain, type: 'onsite' });
        if (result?.payment_id) {
          normalizedData.payment_id = result.payment_id;
        }

        const seriesData = await getseriesType({ sub_domain: subDomain });
        if (seriesData?.length > 0) {
          normalizedData.series = seriesData[0].series;
        }
      } catch (error) {
        console.error("Error fetching receipt ID:", error);
      }
    }

    //  Finally set form and show modal
    setForm(normalizedData);
    setShowModal(true);
  };

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };
 
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const parseNoteHistory = (note) => {
  try {
    let parsed = note;
    while (typeof parsed === 'string') parsed = JSON.parse(parsed);
    return Array.isArray(parsed) ? parsed : [];
  } catch { return []; }
};
  
   //based country code append country name
  const getCountryName = (code) => {
  const country = dropdownData.countries.find(c => c.code === code);
  return country ? country.name : code;
  };

  // Memoized filtered data based on search query
  const filteredData = useMemo(() => {
 
  return dataList
    .filter((data) => {
      // Text-based search
      const matchesText =
        data.sub_domain.toLowerCase().includes(searchText.toLowerCase()) ||
        data.billing_full_name.toLowerCase().includes(searchText.toLowerCase()) ||
        data.billing_countries.toLowerCase().includes(searchText.toLowerCase());     
      return matchesText;
    })
}, [dataList, searchText]);

 
  const columns = [
    {
      name: '#',
      selector: (row, index) => (currentPage - 1) * 10 + (index + 1),
      sortable: false,
      width: '60px',
    },
    {
      name: 'Name',
      selector: (row) => row.billing_full_name,
      sortable: true,
      wrap: true,
    },
    {
      name: 'Country',
      selector: (row) => getCountryName(row.billing_countries),
      sortable: true,
      wrap: true,
    },
    {
      name: 'Status',
      selector: (row) => row.onsite_status,
      sortable: true,
      cell: (row) => (
        <span className={`rounded-pill px-3 py-1 text-white ${statusClassMap[row.onsite_status] ?? 'bg-secondary'}`}>
          {statusLabelMap[row.onsite_status] ?? 'Unknown'}
        </span>
      ),
    },
    {
      name: 'Actions',
      cell: (row) => (
        <div>
          <Button className="me-2" variant="warning" size="sm" onClick={() => openModal('edit', row)} > Edit </Button>
          {/* <Button variant="danger" size="sm" onClick={() => openDeleteConfirmModal(row)} > Delete </Button> */}
        </div>
      ),
    },
  ];
 
  return (
    <div className="d-flex">
      <Sidebar />
      <div className="main-content w-100">
        <Header />
        {loading ? (
        <div
            className="d-flex justify-content-center align-items-center w-100"
            style={{ minHeight: "300px" }}
          >
            <Spinner /> {/* Centered Spinner */}
          </div>
                  ) :(
          <div>
        <div className="container-fluid p-4">
          <div className="row">
            <div className="col-8">
            <p className='fs-4 text-dark'>Conference Management / Participant Form / Onsite Participant Form</p>
            </div>
            <div className="col-4 text-end">
            <button className="btn btn-primary mb-3" onClick={() => openModal('add')}>
                Add
            </button>
            </div>
          </div>
 
          <DataTable
            columns={columns}
            data={filteredData}
            pagination
            search
            highlightOnHover
            responsive
            striped
            paginationPerPage={10}
            paginationRowsPerPageOptions={[10, 20, 50, 100, 200, 500]}
            onChangePage={handlePageChange}
            subHeader
            subHeaderComponent={
              <div>
                <input className="form-control" type="text" placeholder="Search" value={searchText}
                  onChange={handleSearchChange}
                />
              </div>
            }
          />
 
          {/* Modal for Add/Edit data */}
          <Modal show={showModal} backdrop="static" className='modal-xl' onHide={() => setShowModal(false)}>
            <Modal.Header closeButton>
              <Modal.Title>{modalType === 'add' ? 'Add' : 'Edit'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <div className='row'>
                <Form.Group className="col-md-4 mb-3">
                <Form.Label className='fs-5 text-dark'>Payment Receipt ID<span className="text-danger fs-4"> * </span></Form.Label>
                <Form.Control type="text" name="payment_id" value={form.payment_id}  />
                </Form.Group>
                <Form.Group className="col-md-4 mb-3">
                  <Form.Label className='fs-5 text-dark'>Series <span className="text-danger fs-4"> * </span></Form.Label>
                    <Form.Control type="text" name="series" value={form.series} readOnly />
                </Form.Group>
               
                <Form.Group className="col-md-4 mb-3">
                <Form.Label className='fs-5 text-dark'>Payment Mode<span className="text-danger fs-4"> * </span></Form.Label>

                <Form.Control
                    type="text"
                    name="payment_type"
                    value="onsite"
                    disabled
                />
                <Form.Control.Feedback type="invalid">  {errors.payment_type} </Form.Control.Feedback>
                </Form.Group>
                </div>
                <div className='row'>
                <div className="col-md-12">
                    <h5>Billing Address</h5>
                </div>
                </div>
                <div class="row">
                <Form.Group className="col-md-4 mb-3">
                  <Form.Label className='fs-5 text-dark'>Full Name <span className="text-danger fs-4"> * </span></Form.Label>
                  <Form.Control type="text" name="billing_full_name" value={form.billing_full_name} onChange={handleChange} isInvalid={!!errors.billing_full_name}/>
                  <Form.Control.Feedback type="invalid">  {errors.billing_full_name} </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="col-md-4 mb-3">
                  <Form.Label className='fs-5 text-dark'>Email <span className="text-danger fs-4"> * </span></Form.Label>
                  <Form.Control type="email" name="billing_email" value={form.billing_email} onChange={handleChange} isInvalid={!!errors.billing_email}/>
                  <Form.Control.Feedback type="invalid">  {errors.billing_email} </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="col-md-4 mb-3">
                  <Form.Label className='fs-5 text-dark'>Phone No <span className="text-danger fs-4"> * </span></Form.Label>
                  <Form.Control type="text" name="billing_phone_no" value={form.billing_phone_no} onChange={handleChange} isInvalid={!!errors.billing_phone_no}/>
                  <Form.Control.Feedback type="invalid">  {errors.billing_phone_no} </Form.Control.Feedback>
                </Form.Group>          
                <Form.Group className="col-md-4 mb-3">
                <Form.Label className='fs-5 text-dark'>Choose the Country <span className="text-danger fs-4"> * </span></Form.Label>
                <Form.Control className="form-select mb-3" as="select" name="billing_countries" value={form.billing_countries} onChange={handleChange} isInvalid={!!errors.billing_countries}>
                    <option value="">Select</option>
                    {dropdownData.countries.map((countries) => (
                        <option key={countries.code} value={countries.code}>
                        {countries.name}
                        </option>
                    ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">  {errors.billing_countries} </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="col-md-8 mb-3">
                  <Form.Label className='fs-5 text-dark'>Address <span className="text-danger fs-4"> * </span></Form.Label>
                  <Form.Control type="text" name="billing_address" value={form.billing_address} onChange={handleChange} isInvalid={!!errors.billing_address}/>
                  <Form.Control.Feedback type="invalid">  {errors.billing_address} </Form.Control.Feedback>
                </Form.Group>
                </div>
                <div className='row'>
                <div className="col-md-12">
                    <h5>Payment Description</h5>
                </div>
                </div>
 
                <div className='row'>
                <Form.Group className="col-md-4 mb-3">
                <Form.Label className='fs-5 text-dark'>Choose the Currency <span className="text-danger fs-4"> * </span></Form.Label>
                <Form.Control className="form-select mb-3" as="select" name="currency_type" value={form.currency_type} onChange={handleChange} isInvalid={!!errors.currency_type}>
                    <option value="">Select</option>
                    {dropdownData.currencyType.map((currencyType) => (
                        <option key={currencyType.type} value={currencyType.type}>
                        {currencyType.type}
                    </option>
                ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">  {errors.currency_type} </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="col-md-4 mb-3">
                  <Form.Label className='fs-5 text-dark'>Registration Amount <span className="text-danger fs-4"> * </span></Form.Label>
                  <Form.Control type="number" name="reg_amount" value={form.reg_amount} onChange={handleChange} isInvalid={!!errors.reg_amount}/>
                  <Form.Control.Feedback type="invalid">  {errors.reg_amount} </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="col-md-4 mb-3">
                  <Form.Label className='fs-5 text-dark'>No. of Ticket <span className="text-danger fs-4"> * </span></Form.Label>
                  <Form.Control type="number" name="no_of_ticket" value={form.no_of_ticket} onChange={handleChange} isInvalid={!!errors.no_of_ticket}/>
                  <Form.Control.Feedback type="invalid">  {errors.no_of_ticket} </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="col-md-4 mb-3">
                <Form.Label className='fs-5 text-dark'>Registration Type <span className="text-danger fs-4">*</span></Form.Label>
                <Form.Control className="form-select mb-3" as="select" name="reg_type" value={form.reg_type} onChange={handleChange} isInvalid={!!errors.reg_type}>
                    <option value="">Select</option>
                    {dropdownData.regType.map((regtype) => (
                        <option key={regtype.type} value={regtype.type}>
                        {regtype.type}
                    </option>
                ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">  {errors.reg_type} </Form.Control.Feedback>
                </Form.Group>
               {/* Conditionally render the Registration Category field */}
              <Form.Group className="col-md-8 mb-3">
                <Form.Label className='fs-5 text-dark' style={{ display: showCategoryDropdown ? "block" : "none" }}>
                  Registration Category
                </Form.Label>
                <Form.Control
                  className="form-select mb-3"
                  as="select"
                  name="reg_category"
                  value={form.reg_category}
                  onChange={handleChange}
                  isInvalid={!!errors.reg_category}
                  style={{ display: showCategoryDropdown ? "block" : "none" }}
                >
                  <option value="">Select</option>
                  {filteredRegistrationCategories.map((category) => (
                    <option key={category.id} value={category.category}>
                      {category.category}
                    </option>
                  ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">{errors.reg_category}</Form.Control.Feedback>
                </Form.Group>
                {/* Notes & History — Edit mode only */}
                {modalType === 'edit' && (
                <div className='row'>
                  <div className="col-md-12 mb-2 d-flex align-items-center gap-3">
                    <h5 className="mb-0">Notes</h5>
                  </div>

                  {/* History Timeline */}
                  {form.notes?.length > 0 && (
                    <div className="col-md-12 mb-3">
                      <p className="text-muted small fw-semibold mb-2">Recent Changes</p>
                      <div className="border rounded p-2" style={{ maxHeight: '220px', overflowY: 'auto', backgroundColor: '#f8f9fa' }}>
                        {form.notes.slice().reverse().map((n, i, arr) => (
                          <div key={i} style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '10px' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '20px', marginRight: '10px', flexShrink: 0 }}>
                              <div style={{ width: '10px', height: '10px', borderRadius: '50%', background: '#6c757d', marginTop: '3px' }} />
                              {i !== arr.length - 1 && (
                                <div style={{ width: '2px', background: '#dee2e6', marginTop: '3px', minHeight: '28px' }} />
                              )}
                            </div>
                            <div>
                              <div className="small mb-1">{n.value}</div>
                              {/* Status badge stored per note */}
                              {n.status && (
                                <span className={`badge me-1 text-white ${
                                  n.status === 'Approved' ? 'bg-success' :
                                  n.status === 'Closed'   ? 'bg-danger'  : 'bg-warning'
                                }`}>
                                  {n.status}
                                </span>
                              )}
                              <div className="text-muted" style={{ fontSize: '0.75rem' }}>{n.date}</div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Note Input */}
                  <Form.Group className="col-md-12 mb-3">
                    <Form.Label className='fs-5 text-dark'>
                      Add Note <span className="text-danger fs-4"> * </span>
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      name="note"
                      value={form.note || ''}
                      onChange={handleChange}
                      placeholder="Describe what changed..."
                      isInvalid={!!errors.note}
                    />
                    <Form.Control.Feedback type="invalid">{errors.note}</Form.Control.Feedback>
                  </Form.Group>
                </div>
              )}
                </div>              
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowModal(false)}> Cancel </Button>
              <Button variant="primary" onClick={handleSubmit}> {modalType === 'add' ? 'Add' : 'Save'} </Button>
            </Modal.Footer>
          </Modal>
        </div>
        <Footer />
        </div>
      )};
      </div>
    </div>
  );
};
 
export default OnsiteParticipantForm;